<template>
  <div class="follow-shop">
    <!--<van-nav-bar title="已关注" left-arrow @click-left="onClickLeft" border />-->
    <div class="bg-10px"></div>
    <div class="shop-list-con">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="isError"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="onLoad"
      >
        <van-swipe-cell v-for="(item,i) in items" :name="i" :key="i" :right-width="65" :on-close="onClose" :stop-propagation="true">
          <div class="shop" @click="goMallShop(item)">
            <div class="img-con">
              <img class="img" :src="item.shopAvatar + '?imageView2/0/w/110/h/110'" alt="">
            </div>
            <div class="shop-name-con">
              <div class="shop-name">{{item.shopName}}</div>
              <div class="countFocusUser">{{ item.countFocusUser }}人关注</div>
            </div>
            <div class="date-con">
              {{ item.focusDate | dataFormat('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </div>
          <template slot="right">
            <!--<van-button square type="primary" text="收藏"/>-->
            <div class="remove-attention">取消<br>关注</div>
          </template>
        </van-swipe-cell>

      </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { iFocus, focusShop } from '@/api/mall/mallShop'
export default {
  components: {
  },
  data() {
    return {
      items: [], // 列表数据
      refreshLoading: false,
      loading: false,
      finished: false,
      isError: false,
      page: 1,
      size: 10,
    }
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },

    goMallShop(item){
      this.$router.push({name: 'mallShop', query: {shopId: item.shopId}})
    },

    onClose(clickPosition, instance, detail){
      if(clickPosition==='right'){
        this.onFocusShop(detail.name)
      }
      instance.close()
    },
    onFocusShop(index){
      focusShop({shopId: this.items[index].shopId}).then(res=>{
        // res.data===false 表示已取消关注
        if(!res.data){
          this.items.splice(index,1)
        }
      })
    },


    onRefresh(){
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.items = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
    onLoad() {
      iFocus({page: this.page,size: this.size, shopSysTypes: ['SHOP_SYS_TYPE_KNOWLEDGE']}).then(res => {
        if(res.code===200){ //是否有数据
          let arr = res.data
          // 如果是第一页需手动制空列表
          if (this.page === 1){
            this.items = [];
          }
          // 把请求到的数据添加到列表
          this.items = this.items.concat(arr)
          this.page++
          this.loading = false

        }else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.error = true;
      })
    },
  }
}
</script>

<style scoped lang="less">
.follow-shop{
  .shop-list-con{
    .shop{
      display: flex;padding: 8px 0;border-bottom: 1px solid #efefef;
      .img-con{
        display: inline-flex;justify-content: center;align-items: center;padding: 0 8px;
        .img{
          display: block;width: 55px;height: 55px;border-radius: 50%;
        }
      }
      .shop-name-con{
        flex: 1;display: inline-flex;flex-direction: column;justify-content: center;
        color: rgb(43,43,43);padding: 0 8px;
        .shop-name{font-size: 14px;line-height: 24px;overflow: hidden;margin-bottom: 4px;}
        .countFocusUser{font-size: 12px;}
      }
      .date-con{
        display: inline-flex;justify-content: center;align-items: center;
        font-size: 10px;color: rgb(153,153,153);padding: 0 8px;
      }
    }
    .remove-attention{
      display: inline-flex;justify-content: center;align-items: center;width: 65px;
      height: 100%;background: #F74D4D;font-size: 16px;color: #fcfcfc;
    }
  }
}
</style>